/** Auth pages cannot be the destination after completing authentication. */
export function customerReturnUrl(value: unknown): string {
  if (typeof value !== 'string') return '/promotions';
  const url=value.trim();
  if(!url.startsWith('/')||url.startsWith('//')||url.includes('\\'))return '/promotions';
  const path=url.split(/[?#]/)[0];
  if(/^\/(login|register|forgot-password|reset-password|flow-error)(\/|$)/.test(path))return '/promotions';
  return url;
}
